<template>
  <transition name="fade">
    <div v-if="visible" class="app-toast" :style="customStyle">
      {{ message }}
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const visible = ref(false)
const message = ref('')
const timer = ref<number | null>(null)

function show(msg: string, duration = 2000) {
  message.value = msg
  visible.value = true
  if (timer.value) clearTimeout(timer.value)
  timer.value = window.setTimeout(() => {
    visible.value = false
  }, duration)
}

// 让外部可以调用 show
defineExpose({ show })

// 支持自定义样式 - 修复TypeScript类型错误
const customStyle = {
  position: 'fixed' as const,
  left: '50%',
  top: '45%',
  transform: 'translate(-50%, 0)',
  background: '#00422F',
  color: '#fff',
  borderRadius: '12px',
  fontSize: '18px',
  minWidth: '180px',
  padding: '12px 24px',
  textAlign: 'center' as const,
  zIndex: 9999999, // 提高z-index确保在登录弹窗之上
  boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
